module.exports = __webpack_public_path__ + "img/StepResearch.52da1dc3.png";